import { render } from "./systemCommonTemplate.vue?vue&type=template&id=4e589d55"
import script from "./systemCommonTemplate.vue?vue&type=script&lang=js"
export * from "./systemCommonTemplate.vue?vue&type=script&lang=js"

import "./systemCommonTemplate.vue?vue&type=style&index=0&id=4e589d55&lang=css"

import exportComponent from "C:\\Project\\VuePro\\classCloud\\kclass-index-mtzls\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__